import React from 'react';
import PropTypes from 'prop-types';
import { Button, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';
import { initiateMyLoginAuth } from '../../utils/myLoginAuth';

// Styled button for auth providers with consistent styling
const StyledAuthButton = styled(Button)(({ theme, bgcolor, hovercolor }) => ({
  backgroundColor: bgcolor || theme.palette.primary.main,
  color: '#fff',
  padding: '0 20px 0 50px',
  height: '85px',
  borderRadius: '10% 7% 15% 12% / 78% 28% 71% 40%',
  width: '100%',
  fontSize: '24px',
  fontWeight: 'bold',
  textTransform: 'none',
  marginBottom: theme.spacing(1.5),
  display: 'flex',
  justifyContent: 'flex-start',  
  position: 'relative',
  // '&:before': {
  //   content: '""',
  //   position: 'absolute',
  //   top: 0,
  //   left: 0,
  //   width: '100%',
  //   height: '100%',
  //   backgroundColor: 'rgba(255, 255, 255, 0.1)',
  //   transformOrigin: 'left',
  //   transform: 'scaleX(0)',
  //   transition: 'transform 0.3s ease-out',
    
  // },
  '&:hover': {
    backgroundColor: hovercolor || theme.palette.primary.dark,
    // boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
    // transform: 'translateY(-2px)',
    // '&:before': {
    //   transform: 'scaleX(1)',
    // }
  },
  // '&:active': {
  //   transform: 'translateY(0)',
  //   boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
  // }
}));

const AuthButton = ({
  provider,
  icon,  
  label,
  bgcolor,
  hovercolor,
  to,
  onClick,
  loading = false,
  redirectAfterLogin,
  ...props
}) => {
  const handleClick = () => {
    // If a custom click handler exists, use that first
    if (onClick) {
      onClick();
      return;
    }
    
    // For MyLogin, use the special auth flow when directly accessing the button
    // This is a backup case for legacy code paths
    if (provider === 'mylogin') {
      initiateMyLoginAuth(redirectAfterLogin);
    }
  };
  
  // If the button should navigate to a route using React Router
  // Note: Retaining this for backward compatibility, but the unified UI
  // will prefer onClick now
  if (to) {
    return (
      <StyledAuthButton
        component={RouterLink}
        to={to}
        bgcolor={bgcolor}
        hovercolor={hovercolor}
        startIcon={loading ? <CircularProgress size={20} color="inherit" /> : icon}
        disabled={loading}
        {...props}
      >
        {loading ? 'Please wait...' : label}
      </StyledAuthButton>
    );
  }
  
  // Default button with click handler
  return (
    <StyledAuthButton
      bgcolor={bgcolor}
      hovercolor={hovercolor}
      onClick={handleClick}
      startIcon={loading ? <CircularProgress size={20} color="inherit" /> : icon}
      disabled={loading}
      {...props}
    >
      {loading ? 'Please wait...' : label}
    </StyledAuthButton>
  );
};

AuthButton.propTypes = {
  provider: PropTypes.oneOf(['email', 'emoji', 'google', 'microsoft', 'mylogin']).isRequired,
  icon: PropTypes.node.isRequired,  
  label: PropTypes.string.isRequired,
  bgcolor: PropTypes.string,
  hovercolor: PropTypes.string,
  to: PropTypes.string,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  redirectAfterLogin: PropTypes.string,
};

export default AuthButton;
